
import { Component, Vue, Ref } from "vue-property-decorator";
import VueQr from 'vue-qr';

import { getOpenTongueQr, checkQrcode } from "@/api/open";

import { setCatchByKey } from "@/utils/catch";
import { EnumerateEnum } from "@/enum/enum.enum";

@Component({ name: 'open-tongue-index',
    components: {
        VueQr
    }
})
export default class OpenTongue extends Vue {
    @Ref() qrCodeRef!: VueQr;

    deviceCode = this.$route.query.deviceCode as string;

    qrCodeUid = "";
    qrCodeUrl = "";
    deviceId = "";
    intervalId: NodeJS.Timeout | null = null;

    userInfo = {};

    mounted() {
        this.getOpenTongueQr();
    }

    beforeDestroy() {
        this.clearPageFn();
    }

    clearPageFn() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    getOpenTongueQr() {
        getOpenTongueQr({
            deviceCode: this.deviceCode,
            platform: "pc-client"
        }).then((res: any) => {
            console.log(res);
            const { qrCodeUid, qrCodeUrl, deviceId } = res.data;
            this.qrCodeUid = qrCodeUid;
            this.qrCodeUrl = qrCodeUrl;
            this.deviceId = deviceId;

            this.checkQrcode();
            this.intervalId = setInterval(() => {
                this.checkQrcode();
            }, 5000);
        });

    }

    checkQrcode() {
        checkQrcode({
            qrCodeUid: this.qrCodeUid
        }).then((res: any) => {
            this.userInfo = res.data;
            this.clearPageFn();
            this.goCollect();
        });
    }

    goCollect() {
        setCatchByKey(EnumerateEnum.openTongueUser, this.userInfo);
        setCatchByKey(EnumerateEnum.openTongueQrCodeUid, this.qrCodeUid);
        setCatchByKey(EnumerateEnum.openTongueDeviceId, this.deviceId);
        this.$router.push({ 
            path: "/open/tongue-collect", query: { deviceCode: this.deviceCode } 
        });
    }
}
